<template>
  <div class="mb-2">
    <div class="label mt-3 mb-1">{{ label }}</div>

    <div class="btn-group d-flex align-items-center" role="group">
      <button
        type="button"
        class="btn btn-xs"
        v-bind:class="{
          'btn-outline-secondary': value,
          'btn-secondary': !value,
        }"
        v-on:click="updateState(false)"
      >
        {{ negativeText }}
      </button>
      <button
        type="button"
        class="btn btn-xs"
        v-bind:class="{
          'btn-outline-primary': !value,
          'btn-primary': value,
        }"
        v-on:click="updateState(true)"
      >
        {{ positiveText }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import { IBoardItemDto } from '@/apiclient/apiclient_generated';

  @Component({})
  export default class BoardItemSwitcher extends Vue {
    @Prop() label;
    @Prop() negativeText: string;
    @Prop() positiveText: string;
    @Prop() value: boolean;

    @Prop()
    item: IBoardItemDto;

    updateState(newState) {
      if (this.value !== newState) {
        this.$emit('modelUpdate', newState);
      }
    }
  }
</script>

<style scoped lang="scss">
  .btn-group {
    button {
      flex: 1 1 0;
    }
  }
</style>
